<template>
  <div class="edit-user" v-if="seen" @click="closemodal">
    <div class="setup-name add-user">
      <h3>Edit user account details</h3>
      <form class="form">
        <div class="input">
          <div>
            <label>First Name</label>
            <input type="text" v-model="first_name" />
            <span class="error" v-if="error.first_name">*Required</span>
          </div>
          <div>
            <label>Last Name</label>
            <input type="text" v-model="last_name" class="full" />
            <span class="error" v-if="error.last_name">*Required</span>
          </div>
        </div>
        <div class="input">
          <div>
            <label>Email Address</label>
            <input type="text" v-model="email" />
            <span class="error" v-if="error.email">*Required</span><br>
            <span class="error" v-if="error.format">Invalid email address</span>
            <span class="error" v-if="error.user_email_exist">Email address already in use</span>
          </div>
          <div>
            <label>Phone Number</label>
            <input type="text" v-model="phone" class="full" />
          </div>
        </div>
        <!--<div class="input password-field">
                            <div>
                                <label>Password(Optional)</label>
                                <input type="password" v-model="password" />
                                <span class="error" v-if="error.password">*Required</span>
                                <span class="error" v-show="error.password_length">Not less than 8 characters is required</span>
                            </div>
                            <div>
                                <label>Confirm Password(Optional)</label>
                                <input type="password" v-model="con_password" />
                                <span class="error" v-if="error.con_password">*Required</span>
                                <span class="error" v-show="error.con_password_length">Not less than 8 characters is required</span>
                            </div>
                        </div>-->
        <div class="input not">
          <label>Department</label>
          <select v-model="user_department">
            <option value="">Select Department</option>
            <option v-for="(department, index) in departments" :value=department._id :key=index>{{ department.name }}
            </option>
          </select>
          <span class="error" v-if="error.user_department">*Required</span>
        </div>
        <div class="input not">
          <label>Allocate Space to User</label>
          <div>
            <input type="number" v-model="size" value="100" :disabled="is_disable" @blur="check_space_allocated"
              @input="check_space" @change="check_space">
            <select style="padding: .6em 1em" v-model="unit" @change="check_unit" :disabled="is_disable">
              <option value="MB">MB</option>
              <option value="GB">GB</option>
            </select>
            &nbsp;&nbsp; <label><input type="checkbox" v-model="is_disable" /> Unlimited</label>
          </div>
        </div>
        <div class="input">
          <strong>Total Space Remaining: </strong> &nbsp;&nbsp;<span>{{ $sizeFormat(total_space_remaining) }}</span>
        </div>
        <div class="input">
          <strong>Total Space Used: </strong> &nbsp;&nbsp;<span>{{ $sizeFormat(total_space_used) }}</span>
        </div>
        <div class="input">
          <strong>Total Allocated Space: </strong> &nbsp;&nbsp;<span>{{ $sizeFormat(total_space) }}</span>
        </div>
        <div class="submit">
          <span type="button" @click="edit_user">Save</span>&nbsp;&nbsp;<span class="clos"
            @click="closemodal">Cancel</span>
        </div>
      </form>
    </div>
  </div>
</template>
<style scoped>
.edit-user .add-user form div.submit span {
  padding: .9em .8em !important;
  font-size: 15px !important;
  font-weight: normal;
  width: 100px;
  cursor: pointer;
}

.edit-user .add-user form .input div input {
  width: 100%;
}

.edit-user .add-user form .not div input {
  margin-right: .6em;
  width: 40%;
}

.edit-user .add-user form .not div label input {
  margin-right: .2em;
  width: auto;
}
</style>
<script>
import AuthenticationService from '@/services/AuthenticationService'
import cookies from '@/services/cookies'
export default {
  data() {
    return {
      seen: false,
      text: '',
      company_name: '',
      company_phone: '',
      company_address: '',
      company_address_city: '',
      department_name: '',
      country: '',
      create_folder: false,
      question: '',
      answer: '',
      total_space: 0,
      total_space_remaining: 0,
      total_space_used: 0,
      total_user_used_space: 0,
      error: {
        name: false,
        country: false,
        department_name: false,
        department_name_exist: false,
        question: false,
        answer: false,
        password: false,
        con_password: false,
        first_name: false,
        last_name: false,
        format: false,
        email: false,
        password_length: false,
        con_password_length: false,
        user_department: false,
        user_email_exist: false
      },
      user_department: '',
      department: '',
      departments: [],
      name: '',
      post: true,
      account_type: '',
      department_created: false,
      next: 4,
      last_name: '',
      first_name: '',
      email: '',
      password: '',
      con_password: '',
      phone: '',
      size: 100,
      unit: 'MB',
      is_disable: false,
      tag: 0,
      space_error: false,
      users: [],
      user: {},
      index: 0,
      str: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    }
  },
  methods: {
    load(index, user, total_space, total_space_remaining, total_space_used, departments) {
      this.departments = departments
      this.total_space = total_space
      this.total_space_remaining = total_space_remaining
      this.total_space_used = total_space_used

      this.index = index

      this.user = user

      this.first_name = user.firstname
      this.last_name = user.lastname
      this.email = user.email
      this.phone = user.phone
      this.user_department = user.department_id
      this.size = user.unit == 'MB' ? user.size / 1048576 : user.size / 1073741824
      this.unit = user.unit
      this.seen = true
    },
    revertSize() {
      this.size = 100
    },
    check_space_allocated() {
      if (this.unit == 'MB') {
        // If allocated size is less than 100MB
        if ((1048576 * this.size) < 104857600) {
          this.$refs.warning.load('less')
          this.size = 100
          return
        }
      }

      if (this.unit == 'GB') {
        if (this.total_space < (1073741824 * this.size)) {
          this.$refs.warning.load('high', this.total_space)
        }
      }
    },
    totalspaceremaining() {
      if (this.total_space_used > this.total_space) {
        return 0
      } else {
        return this.total_space - this.total_space_used
      }
    },
    totalspaceused() {
      this.total_space_used = this.total_user_used_space + (1048576 * this.size)
    },
    check_unit() {
      if (this.unit === 'MB') {

      } else {
        // this.total_space_remaining = 1048576 * this.size
      }
    },
    loader() {
      this.$parent.loader()
    },
    close_loader() {
      this.$parent.close_loader()
    },
    low_warning() {
      this.$parent.low_warning()
    },
    high_warning() {
      this.$parent.high_warning()
    },
    check_space(evt) {
      let size = this.$spaceFormat(this.size, this.unit)

      if (this.unit == 'MB') {
        // If allocated size is less than 100MB
        if ((1048576 * this.size) < 104857600) {
          this.space_error = true
        } else {
          this.total_space_remaining = this.totalspaceremaining()
          this.totalspaceused()
        }
      }

      if (this.unit == 'GB') {
        if (this.total_space < (1073741824 * this.size)) {
          this.$refs.warning.load('high', this.total_space)
        } else {
          this.total_space_remaining = this.totalspaceremaining()
          this.totalspaceused()
        }
      }
    },
    edit_user() {
      this.post = true

      if (this.first_name == '') {
        this.error.first_name = true
        this.post = false
      } else {
        this.error.first_name = false
      }

      if (this.last_name == '') {
        this.error.last_name = true
        this.post = false
      } else {
        this.error.last_name = false
      }

      if (this.email == '') {
        this.error.email = true
        this.post = true
      } else {
        this.error.email = false

        if (this.str.test(this.email) === false) {
          this.error.format = true
          this.post = false
        } else {
          this.error.format = false
        }
      }

      if (this.departments.length) {
        if (this.user_department == '') {
          this.error.user_department = true
          this.post = false
        } else {
          this.error.user_department = false
        }
      }

      if (this.post === true) {
        this.loader()

        let that = this

        let data = {
          token: cookies.getCookie('temp_token'),
          user_id: this.user._id,
          email: this.email,
          firstname: this.first_name,
          lastname: this.last_name,
          phone: this.phone,
          department: this.user_department,
          size: this.is_disable ? 'Unlimited' : this.size,
          unit: this.unit
        }

        AuthenticationService.edit_user(data).then(res => {
          if (res.data.data === true) {
            that.close_loader()
            let size = that.unit == 'MB' ? that.size * 1048576 : that.size * 1073741824
            that.user.email = that.email
            that.user.firstname = that.first_name
            that.user.lastname = that.last_name
            that.user.phone = that.phone
            that.user.department = res.data.department
            that.user.department_id = that.user_department
            that.user.size = that.is_disable ? 'Unlimited' : size
            that.user.unit = that.unit

            that.seen = false

            that.$parent.update_user(that.user, that.index)
          }

          if (res.data.error == true) {
            that.close_loader()
            that.error.user_email_exist = true
          }

          if (res.data.data == false) {
            that.$router.push('login')
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    closemodal(evt) {
      if (evt.target.className === 'edit-user' || evt.target.className === 'clos') {
        this.seen = false
      }
    }
  },
  mounted() {
    let data = {
      token: cookies.getCookie('temp_token')
    }

    let that = this

    this.$socket.emit('get-departments', data, function (data) {
      if (data.data === true) {
        that.departments = data.departments
      }
    })
  }
}
</script>
